import { COLORS, SPACING } from '@alto/design-library-tokens';
import { Body, Icon, Link, XsSpacing } from '@alto/design-system';
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

type LocalCrumb = {
  text: string;
  to?: string;
};

type NodeCrumb = {
  link: React.ReactNode;
  key: string;
};

type Breadcrumb = LocalCrumb | NodeCrumb;

type Props = {
  readonly breadcrumbs: Breadcrumb[];
};
const BreadcrumbContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  margin: 0 0 ${SPACING.STATIC.SM.rem};
`;

const BreadcrumbAnchor = styled(NavLink)<{ color: string }>`
  text-decoration: none;
  color: ${({ color }) => color};
`;

type BCType = {
  readonly breadcrumb: Breadcrumb;
};

const isNodeCrumb = (breadcrumb: unknown): breadcrumb is NodeCrumb => {
  return !!(breadcrumb as NodeCrumb).key;
};

const BCText = ({ breadcrumb }: BCType) => {
  if (isNodeCrumb(breadcrumb)) return <>{breadcrumb.link}</>;

  return <Body>{breadcrumb.text}</Body>;
};

const BCLink = ({ breadcrumb }: BCType) => {
  if (isNodeCrumb(breadcrumb)) return <>{breadcrumb.link}</>;
  return (
    <BreadcrumbAnchor
      to={breadcrumb.to ?? '/'}
      color={COLORS.TEXT_COLORS.SECONDARY}
    >
      {breadcrumb.text}
    </BreadcrumbAnchor>
  );
};

export const Breadcrumbs: React.FC<Props> = ({ breadcrumbs }) => {
  return (
    <BreadcrumbContainer>
      {breadcrumbs.map((breadcrumb, i) => {
        if (i === breadcrumbs.length - 1) {
          return (
            <BCText
              key="final"
              breadcrumb={breadcrumb}
            />
          );
        }

        return (
          <React.Fragment key={`link-${isNodeCrumb(breadcrumb) ? breadcrumb.key : breadcrumb.to}`}>
            <Link>
              <BCLink breadcrumb={breadcrumb} />
            </Link>
            <Icon
              name="chevronright-small"
              type="grey"
            />
            <XsSpacing />
          </React.Fragment>
        );
      })}
    </BreadcrumbContainer>
  );
};
